import { useEffect, useRef, useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export const SUPPORT_STATUS = { OPEN: "Yanıt bekliyor", ANSWERED: "Yanıtlandı", CLOSED: "Kapatıldı" };

export const ThreadView = ({ threadId, admin, onChanged, compact }) => {
  const [data, setData] = useState(null);
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);
  const base = admin ? `/admin/support/threads/${threadId}` : `/support/threads/${threadId}`;
  const load = () => api.get(`${base}/messages`).then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, [threadId]);
  useEffect(() => { endRef.current?.scrollIntoView({ block: "end" }); }, [data?.messages.length]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSending(true);
    try { await api.post(`${base}/messages`, { text }); setText(""); load(); onChanged?.(); } catch (x) { toast.error(formatApiError(x.response?.data?.detail)); }
    setSending(false);
  };
  if (!data) return <div className="p-6 text-center text-sm text-slate-500">Yükleniyor...</div>;
  const mine = admin ? "ADMIN" : "USER";
  return (
    <div className="flex flex-col h-full min-h-0" data-testid="support-thread">
      <div className={`flex-1 overflow-y-auto space-y-2 p-3 bg-slate-50 ${compact ? "max-h-80" : ""}`} data-testid="support-messages">
        {data.messages.map((m) => (
          <div key={m.id} className={`flex ${m.sender === mine ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[80%] rounded-2xl px-3 py-2 text-sm ${m.sender === mine ? "bg-slate-900 text-white rounded-br-sm" : "bg-white border rounded-bl-sm"}`} data-testid="support-message">
              <div className="whitespace-pre-wrap">{m.text}</div>
              <div className={`text-[10px] mt-0.5 ${m.sender === mine ? "text-slate-300" : "text-slate-400"}`}>{m.sender === "ADMIN" ? "Destek · " : ""}{m.sender_name} · {new Date(m.created_at).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}</div>
            </div>
          </div>
        ))}
        <div ref={endRef} />
      </div>
      {data.thread.status === "CLOSED" ? <div className="p-3 text-xs text-center text-slate-500 border-t">Bu görüşme kapatıldı.</div> : (
        <form onSubmit={send} className="flex gap-2 p-2 border-t bg-white">
          <Input data-testid="support-input" value={text} onChange={(e) => setText(e.target.value)} placeholder="Mesajınızı yazın..." />
          <Button data-testid="support-send-btn" size="icon" type="submit" disabled={sending} className="bg-emerald-600 hover:bg-emerald-700 shrink-0">{sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}</Button>
        </form>
      )}
    </div>
  );
};
